import scribdAuthorize from 'app/assets/javascripts/scribd/scribd_oauth.js';
import { player } from "app/assets/javascripts/new_player/selectors";

export const ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION = 5;
export const CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS = 2;

export const getShouldShowBannerNotificationsUX = (allowedContentCount, contentAccountGateDataLength, contentCountWithoutBannerNotifications) => {
  return {
    shouldShowBanner: ((allowedContentCount - contentAccountGateDataLength) <= contentCountWithoutBannerNotifications),
    remainingDocCount: allowedContentCount - contentAccountGateDataLength
  };
};

export const getShouldShowReaderBlur = (
  allowedContentCount,
  contentAccountGateDataLength
) => {
  return contentAccountGateDataLength > allowedContentCount;
};

const logEvent = (eventName) => {
  const slideshow = window.slideshare_object.slideshow;
  const options = {
    slideshow_id: slideshow.id,
    slideshow_created_at: slideshow.created_at,
    slideshow_category: window.slideshare_object.gam_cat_name,
    slideshow_language: slideshow.language,
    slideshow_format: slideshow.type,
  };

  if (typeof amplitude !== 'undefined') {
    amplitude.getInstance().logEvent(eventName, options);
  }
}

export const logViewRestrictionEvent = (contentViewedCount) => {
  const isShowingBannerForFirstTime =
    contentViewedCount ===
    ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION - CONTENT_COUNT_TO_START_RENDERING_BANNER_NOTIFICATIONS; 
  const isShowingRestrictionForFirstTime =
    contentViewedCount === ALLOWED_CONTENT_COUNT_WITHOUT_SUBSCRIPTION;

  if (isShowingBannerForFirstTime) {
    logEvent('view_restriction_banner_shown');
  } else if (isShowingRestrictionForFirstTime) {
    logEvent('view_restriction_threshold_hit');

  }
};

const getBannerNotificationText = (remainingDocCount, slideshare_object) => {
  const utils = slideshare_object.utils;
  if (remainingDocCount < 0) {
    return utils.i18n('slideshow.foundation_slideview.limit_content_without_account.notification_banner_ran_out_text');
  } else if (remainingDocCount === 0) {
    return utils.i18n('slideshow.foundation_slideview.limit_content_without_account.notification_banner_last_document_text');
  } else {
    return utils.i18n('slideshow.foundation_slideview.limit_content_without_accoun.notification_banner_text', { count: remainingDocCount });
  }
};

const handleScribdAuthorize = () => {
  const slideshare_object = window.slideshare_object;
  const slideshow = slideshare_object && slideshare_object.slideshow;
  scribdAuthorize({
    from_source: `${slideshow.ss_url}?subscription_success_banner=show`,
    slideshow_id: slideshow.id,
    isContentGate: true,
  });
};

export const handleBannerNotification = (shouldShowBanner, remainingDocCount, slideshare_object) => {
  if (shouldShowBanner) {
    const $banner = $('.limit-notification');
    const $notificationWarningtextElem =  $banner.find('#notification-warning-text');
    $notificationWarningtextElem.empty();
    $notificationWarningtextElem.append(getBannerNotificationText(remainingDocCount, slideshare_object));
    $banner.find('#notification-warning-link').on('click', handleScribdAuthorize);
    $banner
      .css('opacity', 0)
      .slideDown(400)
      .animate(
        { opacity: 1 },
        { queue: false, duration: 400 }
      );
    return;
  }
};

export const showLimitOverlay = () => {
  const $limitOverlay = $('.limit-overlay');
  $limitOverlay.find('#sign-up-with-scribd').on('click', handleScribdAuthorize);
  $limitOverlay.css('display', '');
  player.addClass('guest-limit');
};

export const hideLimitOverlay = () => {
  const $limitOverlay = $('.limit-overlay');
  $limitOverlay.css('display', 'none');
  player.removeClass('guest-limit');
}
